// extracted by mini-css-extract-plugin
export default {"content":"BadgeItem-content-6ef5a367420b8ec43ba9337aa3a25e38","removeButton":"BadgeItem-removeButton-fedc6e7a1f474a8acb780848e4ed765d"};